export const getComponentBarChartOption = (chartData) => {
  const sorted = [...chartData].sort((a, b) => a.Value - b.Value);

  return {
    animation: false,
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
      backgroundColor: "rgba(15,23,42,0.92)",
      textStyle: { color: "#fff", fontSize: 12 },
      borderWidth: 0,
    },
    grid: { left: 90, right: 50, top: 10, bottom: 10 },
    xAxis: {
      type: "value",
      show: false, 
      splitLine: { show: false }
    },
    yAxis: {
      type: "category",
      data: sorted.map(d => d.Component),
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: { color: "#64748b", fontSize: 11, margin: 12 }
    },
    series: [
      {
        type: "bar",
        data: sorted.map(d => ({
          value: d.Value,
          itemStyle: { color: d.color, borderRadius: [0, 4, 4, 0] }
        })),
        barWidth: 16, 
        label: {
          show: true,
          position: "right",
          formatter: "{c} Cr",
          color: "#94a3b8",
          fontSize: 10
        }
      }
    ]
  };
};

export const getTrendLineChartOption = (chartData) => ({
  animation: false,
  tooltip: {
    trigger: "axis",
    confine: true,
    backgroundColor: "rgba(15,23,42,0.92)",
    borderWidth: 0,
    textStyle: { color: "#f8fafc", fontSize: 12 },
    formatter: function(params) {
      if (!params || !params.length) return "";
      const dataIndex = params[0].dataIndex;
      const dataPoint = chartData[dataIndex];
      return `
        <div style="font-weight:600;margin-bottom:6px;padding-bottom:4px;border-bottom:1px solid rgba(255,255,255,0.1)">${dataPoint.Date}</div>
        <div style="display:flex;justify-content:space-between;gap:12px;margin-bottom:2px;">
          <span style="color:#94a3b8">Value:</span> 
          <span style="font-weight:600;color:#fbbf24">${dataPoint.Value} Cr</span>
        </div>
        <div style="display:flex;justify-content:space-between;gap:12px;">
          <span style="color:#94a3b8">Qty:</span> 
          <span style="font-weight:600">${dataPoint.Qty} L</span>
        </div>
      `;
    }
  },
  grid: { left: 60, right: 20, bottom: 45, top: 20 },
  xAxis: {
    type: "category",
    boundaryGap: false, 
    data: chartData.map(d => d.Date),
    axisLabel: { rotate: 35, color: "#94a3b8", fontSize: 9, margin: 12 },
    axisLine: { lineStyle: { color: "#e2e8f0" } },
    axisTick: { show: false }
  },
  yAxis: {
    type: "value",
    axisLabel: { color: "#94a3b8", fontSize: 10, formatter: "{value} Cr" },
    splitLine: { lineStyle: { color: "#f1f5f9" } },
    axisLine: { show: false },
    axisTick: { show: false }
  },
  series: [
    {
      name: "Total Value",
      type: "line",
      data: chartData.map(d => ({
        value: d.Value,
        itemStyle: { color: d.isSelectedMonth ? "#ea580c" : "#3b82f6" } 
      })),
      lineStyle: { color: "#3b82f6", width: 2 },
      areaStyle: { 
        color: {
          type: "linear", x: 0, y: 0, x2: 0, y2: 1,
          colorStops: [
            { offset: 0, color: "rgba(59, 130, 246, 0.12)" },
            { offset: 1, color: "rgba(59, 130, 246, 0.02)" }
          ]
        }
      },
      symbol: "circle",
      symbolSize: 6,
    },
  ],
});
